import React from 'react';
import { useAuth } from '@24i/nxg-sdk-smartott/src/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { useIdentityManagerValidation } from '@24i/nxg-sdk-smartott-shared/src/hooks/useIdentityManagerValidation';
import withErrorModal, { WithErrorModalProps } from '../GenericModal/hoc/ErrorModal';

const IdentityManagerValidationComponent: React.FC<WithErrorModalProps> = ({ openErrorModal }) => {
    const { logout } = useAuth();
    const { t } = useTranslation();

    useIdentityManagerValidation({
        onLogout: async () => {
            await logout({ skipUserDataClientRequest: true });
            openErrorModal(
                t('error.E25.title'),
                t('error.E25.body', { errorCode: '401' }),
                false,
                String(t('common.continue'))
            );
        },
    });

    return null;
};

export const IdentityManagerValidation = withErrorModal(IdentityManagerValidationComponent);
